import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        @media (max-width: 768px) {
            padding: 40px 16px;
        }

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.2em;
                }

                @media (max-width: 480px) {
                    font-size: 1.75em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;

        @media (max-width: 768px) {
            font-size: 0.95em;
            gap: 6px;
        }
        
        a {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1400px;
        margin: -40px auto 0;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 10;
        box-sizing: border-box;

        @media (max-width: 768px) {
            margin: -24px auto 0;
            padding: 0 12px;
        }
        
        .hierarchy-container {
            display: flex;
            flex-direction: column;
            gap: 40px;
            align-items: center;
            width: 100%;

            @media (max-width: 768px) {
                gap: 24px;
            }
        }

        .tier-row {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 30px;
            width: 100%;

            @media (max-width: 768px) {
                gap: 16px;
            }
        }

        .team-avatar-card {
            background: #ffffff;
            border-radius: 24px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
            border: 1px solid rgba(0,0,0,0.03);
            padding: 30px 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            width: 260px;
            box-sizing: border-box;
            transition: transform 0.3s ease, box-shadow 0.3s ease;

            @media (max-width: 600px) {
                width: 100%;
                max-width: 320px;
                padding: 24px 16px;
                border-radius: 18px;
            }

            &:hover {
                transform: translateY(-8px);
                box-shadow: 0 20px 40px rgba(0, 169, 196, 0.1);
            }

            .avatar-wrapper {
                width: 130px;
                height: 130px;
                border-radius: 50%;
                overflow: hidden;
                margin-bottom: 20px;
                border: 4px solid #f1f5f9;
                box-shadow: 0 8px 20px rgba(0,0,0,0.06);
                transition: transform 0.5s ease, border-color 0.3s ease;

                @media (max-width: 600px) {
                    width: 110px;
                    height: 110px;
                    margin-bottom: 14px;
                }

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: top;
                }
            }

            &:hover .avatar-wrapper {
                transform: scale(1.05);
                border-color: #00A9C4;
            }

            h2 {
                margin: 0 0 10px 0;
                color: #1e293b;
                font-size: 1.15em;
                font-weight: 700;
                line-height: 1.3;
            }

            .desc {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;

                p {
                    color: #64748b;
                    font-size: 0.95em;
                    line-height: 1.5;
                    margin: 0;
                }
            }

            .details-btn {
                margin-top: 15px;
                display: inline-flex;
                align-items: center;
                gap: 5px;
                color: #00A9C4;
                font-weight: 700;
                text-decoration: none;
                font-size: 0.9em;
                transition: gap 0.2s ease;

                &:hover {
                    gap: 8px;
                }
            }

            &.featured {
                width: 320px;
                padding: 40px 30px;
                background: linear-gradient(to bottom, #ffffff, #f0fbfc);
                border: 1px solid rgba(0,169,196,0.1);
                box-shadow: 0 15px 35px rgba(0, 169, 196, 0.08);

                @media (max-width: 600px) {
                    width: 100%;
                    max-width: 320px;
                    padding: 26px 18px;
                }
                
                .avatar-wrapper {
                    width: 160px;
                    height: 160px;
                    border-color: #e0f2fe;

                    @media (max-width: 600px) {
                        width: 130px;
                        height: 130px;
                    }
                }

                h2 {
                    font-size: 1.35em;
                    color: #0369a1;

                    @media (max-width: 600px) {
                        font-size: 1.2em;
                    }
                }

                .title-primary {
                    color: #0ea5e9;
                    font-weight: 700;
                    margin-bottom: 5px;
                }
                
                .title-secondary {
                    color: #64748b;
                }
            }
        }
    `
};

export default S;